// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productsStickyFooterStyles } from "@bg/App/Components/OnePageCheckout/ProductsStickyFooter";
import { fontConfig } from "@bg/XDL/PreStyle/typography";
import { css } from "styled-components";

productsStickyFooterStyles.container = {
    css: css`
        height: 86px;
        padding: 12px 10px;
        gap: 8px;
        display: flex;
        flex-direction: column;
    `,
};

productsStickyFooterStyles.InfoSectionWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
    `,
};

productsStickyFooterStyles.innerWrapper = {
    css: css`
        line-height: ${fontConfig.lineHeight.singleLineSmall};
    `,
};

productsStickyFooterStyles.summaryButton = {
    typographyProps: {
        transform: "uppercase",
    },
    variant: "primary",
    sizeVariant: "medium",
    css: css`
        width: 100%;
    `,
};

productsStickyFooterStyles.labelText = {
    weight: fontConfig.weight.bold,
    size: fontConfig.fontSize.small,
    lineHeight: fontConfig.lineHeight.singleLineSmall,
    css: css`
        margin-right: 4px;
    `,
};

productsStickyFooterStyles.valueText = {
    size: fontConfig.fontSize.small,
    lineHeight: fontConfig.lineHeight.singleLineSmall,
};
